<template>
<w-settings-content-template side-title="네트워크 벤더 목록" :default-side="false">
  <div slot="sideContent" class="side-content" style="padding: 0px;">
    <el-scrollbar class="bar-visible">
      <el-menu mode="vertical" class="settings-sub-menu" :default-active="defaultActiveMenu">
        <el-menu-item v-for="(item) in vendorList" :key="item.objCompanyId" :index="item.objCompanyName" @click="onClickVendorList(item)">
          {{item.objCompanyName}}
        </el-menu-item>
      </el-menu>
    </el-scrollbar>
  </div>
  <div slot="content">
    <w-rule-setting-list :target-data="targetData" :vendor-list="vendorList"></w-rule-setting-list>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import NetdeviceAPI from '@/api/common/netdevice';
import WRuleSettingList from './component/RuleSettingList';

export default {
  name: 'WRuleSettings',
  components: {
    WSettingsContentTemplate,
    WRuleSettingList,
  },
  data() {
    return {
      defaultActiveMenu: null,
      targetData: {},
      vendorList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      NetdeviceAPI.getProvidedCompanyList().then((res) => {
        if (res.data.success) {
          this.vendorList = res.data.data;
          this.targetData = this.vendorList[0];
          this.defaultActiveMenu = this.vendorList[0].objCompanyName;
        }
      });
    },
    onClickVendorList(item) {
      this.targetData = item;
    },
  },
};
</script>

<style scoped>
.vendor-list {
  height: 50px;
  width: 100%;
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/RuleViolationSettings/RuleSettings/index.vue